<template>
    <div>
        <Head :title="'Будьте в курсе всех продаж!'" />

        <form
            @submit.prevent="attempt"
            class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto"
        >
            <h2 class="text-2xl text-center font-normal mb-6">
                Добавьте уведомления в Телеграм!
            </h2>

            <div class="mb-5">
                Напишите боту -
                <a class="link-default" target="_blank" :href="botLink"
                    >@yoomarket_notify_bot</a
                >
                сообщение ниже и мы добавим уведомление автоматически:
                <br /><br />
                <div
                    class="break-words mb-5"
                    style="border: 1px solid #0ea5e9; padding: 10px"
                >
                    <a
                        v-html="botText"
                        class="link-default"
                        target="_blank"
                        :href="botLink"
                    ></a>
                </div>

                <span>
                    Мы будем отправлять сообщения о новых заказах, чтобы вы
                    ничего не пропустили! В любой момент уведомления можно
                    отключить.
                </span>
            </div>

            <Button
                class="w-full flex justify-center"
                type="submit"
                :loading="form.processing"
            >
                <span>Добавил</span>
            </Button>

            <div class="flex justify-center mt-3">
                <Button type="button" variant="ghost" @click="attempt">
                    Добавлю позже
                </Button>
            </div>
        </form>

        <Footer />
    </div>
</template>

<script>
import Auth from "@/layouts/Auth";
import Footer from "@/layouts/Footer";
import { Button } from "laravel-nova-ui";

export default {
    name: "TieTelegramPage",

    layout: Auth,

    components: { Footer, Button },

    props: {
        botText: String,
        botLink: String,
    },

    data() {
        return {
            form: null,
        };
    },

    created() {
        this.form = Nova.form();
    },

    methods: {
        async attempt() {
            await this.form.post(Nova.url("/tie-telegram"));
            Nova.visit("/");
        },
    },
};
</script>
